import { lazy } from "react";
import { createBrowserRouter } from "react-router";
import Landing from "./pages/Landing";

const EmotionSelection = lazy(() => import("./pages/EmotionSelection"));
const Login = lazy(() => import("./pages/Login"));
const Register = lazy(() => import("./pages/Register"));
const ForgotPassword = lazy(() => import("./pages/ForgotPassword"));
const ResetPassword = lazy(() => import("./pages/ResetPassword"));
const VerifyEmail = lazy(() => import("./pages/VerifyEmail"));
const UserDashboard = lazy(() => import("./pages/UserDashboard"));
const ListenerDashboard = lazy(() => import("./pages/ListenerDashboard"));
const ListenerProfile = lazy(() => import("./pages/ListenerProfile"));
const ChatDashboard = lazy(() => import("./pages/ChatDashboard"));
const ActiveSession = lazy(() => import("./pages/ActiveSession"));
const BecomeListener = lazy(() => import("./pages/BecomeListener"));
const HowItWorks = lazy(() => import("./pages/HowItWorks"));
const ScheduleSession = lazy(() => import("./pages/ScheduleSession"));
const Profile = lazy(() => import("./pages/Profile"));
const Wellness = lazy(() => import("./pages/Wellness"));
const History = lazy(() => import("./pages/History"));
const Notifications = lazy(() => import("./pages/Notifications"));
const ListenerSchedule = lazy(() => import("./pages/ListenerSchedule"));
const Pricing = lazy(() => import("./pages/Pricing"));
const SafetyPrivacy = lazy(() => import("./pages/SafetyPrivacy"));
const Resources = lazy(() => import("./pages/Resources"));
const HelpCenter = lazy(() => import("./pages/HelpCenter"));
const CrisisResources = lazy(() => import("./pages/CrisisResources"));
const CommunityGuidelines = lazy(() => import("./pages/CommunityGuidelines"));
const ContactUs = lazy(() => import("./pages/ContactUs"));
const TermsOfService = lazy(() => import("./pages/TermsOfService"));
const PrivacyPolicy = lazy(() => import("./pages/PrivacyPolicy"));
const CookiePolicy = lazy(() => import("./pages/CookiePolicy"));
const Disclaimer = lazy(() => import("./pages/Disclaimer"));
const PaymentSuccess = lazy(() => import("./pages/PaymentSuccess"));
const AdminDashboard = lazy(() => import("./pages/AdminDashboard"));
const GrowthHistory = lazy(() => import("./pages/GrowthHistory"));
const IdentityVerification = lazy(() => import("./pages/IdentityVerification"));
const NotFound = lazy(() => import("./pages/NotFound"));

import PrivateRoute from "./components/PrivateRoute";
import PublicRoute from "./components/PublicRoute";

import LayoutWrapper from "./components/LayoutWrapper";

export const router = createBrowserRouter([
  {
    element: <LayoutWrapper />,
    children: [
      {
        path: "/",
        Component: Landing,
      },
      {
        element: <PublicRoute />,
        children: [
          {
            path: "/login",
            Component: Login,
          },
          {
            path: "/register",
            Component: Register,
          },
          {
            path: "/forgot-password",
            Component: ForgotPassword,
          },
          {
            path: "/reset-password",
            Component: ResetPassword,
          },
          {
            path: "/verify-email",
            Component: VerifyEmail,
          },
        ],
      },
      {
        element: <PrivateRoute allowedRole="talking" />,
        children: [
          {
            path: "/select-emotion",
            Component: EmotionSelection,
          },
          {
            path: "/dashboard",
            Component: UserDashboard,
          },
          {
            path: "/dashboard/schedule",
            Component: ScheduleSession,
          },
          {
            path: "/dashboard/wellness",
            Component: Wellness,
          },
          {
            path: "/dashboard/history",
            Component: History,
          },
          {
            path: "/dashboard/chat",
            Component: ChatDashboard,
          },
          {
            path: "/pricing",
            Component: Pricing,
          },
          {
            path: "/payment-success",
            Component: PaymentSuccess,
          },
        ],
      },
      {
        element: <PrivateRoute allowedRole="listener" />,
        children: [
          {
            path: "/listener/dashboard",
            Component: ListenerDashboard,
          },
          {
            path: "/listener/profile",
            Component: ListenerProfile,
          },
          {
            path: "/listener/notifications",
            Component: Notifications,
          },
          {
            path: "/listener/schedule",
            Component: ListenerSchedule,
          },
          {
            path: "/listener/growth",
            Component: GrowthHistory,
          },
          {
            path: "/listener/verify-identity",
            Component: IdentityVerification,
          },
          {
            path: "/dashboard/chat",
            Component: ChatDashboard,
          },
        ],
      },
      {
        element: <PrivateRoute allowedRole="admin" />,
        children: [
          {
            path: "/admin/dashboard",
            Component: AdminDashboard,
          },
        ],
      },
      {
        element: <PrivateRoute />,
        children: [
          {
            path: "/session/active",
            Component: ActiveSession,
          },
          {
            path: "/profile",
            Component: Profile,
          },
        ],
      },
      {
        path: "/become-listener",
        Component: BecomeListener,
      },
      {
        path: "/verify-identity",
        Component: IdentityVerification,
      },
      {
        path: "/how-it-works",
        Component: HowItWorks,
      },
      {
        path: "/safety-privacy",
        Component: SafetyPrivacy,
      },
      {
        path: "/resources",
        Component: Resources,
      },
      {
        path: "/help-center",
        Component: HelpCenter,
      },
      {
        path: "/crisis-resources",
        Component: CrisisResources,
      },
      {
        path: "/community-guidelines",
        Component: CommunityGuidelines,
      },
      {
        path: "/contact",
        Component: ContactUs,
      },
      {
        path: "/terms",
        Component: TermsOfService,
      },
      {
        path: "/privacy",
        Component: PrivacyPolicy,
      },
      {
        path: "/cookies",
        Component: CookiePolicy,
      },
      {
        path: "/disclaimer",
        Component: Disclaimer,
      },
      {
        path: "*",
        Component: NotFound,
      },
    ],
  },
]);

